import {HttpErrorResponse, HttpStatusCode} from '@angular/common/http';
import {TNullable} from '@shared/interfaces/base';

export interface IHttpApiErrorResponse {
  status: number;
  message: string;

  isJson: boolean;

  getErrors(): unknown;
  isBadRequest(): boolean;
  isUnauthorized(): boolean;
  isForbidden(): boolean;
  isConflict(): boolean;
  isNotFound(): boolean;
  isPayloadTooLarge(): boolean;
  /**
   * UnprocessableEntity: 422
   */
  isUnprocessableEntity(): boolean;
  /**
   * status: 423
   */
  isLocked(): boolean;
  /**
   * FailedDependency: 424
   */
  isFailedDependency(): boolean;
  isTooManyRequests(): boolean;
  isInternalServerError(): boolean;
  isNotImplemented(): boolean;
  isBadGateway(): boolean;
  isServiceUnavailable(): boolean;
  isGatewayTimeout(): boolean;
}

export class HttpApiError implements IHttpApiErrorResponse {
  constructor(private readonly reason: HttpErrorResponse) {}

  get status() {
    return this.reason.status || 0;
  }

  get message(): TNullable<string> {
    return this.reason.error.message || this.reason.message || null;
  }

  get isJson() {
    return this.reason.headers.get('content-type') === 'application/json';
  }

  getErrors() {
    return this.reason.error.errors || {};
  }

  isBadRequest() {
    return this.status === HttpStatusCode.BadRequest;
  }

  isUnauthorized() {
    return this.status === HttpStatusCode.Unauthorized;
  }

  isForbidden() {
    return this.status === HttpStatusCode.Forbidden;
  }

  isConflict() {
    return this.status === HttpStatusCode.Conflict;
  }

  isNotFound() {
    return this.status === HttpStatusCode.NotFound;
  }

  isPayloadTooLarge() {
    return this.status === HttpStatusCode.PayloadTooLarge;
  }
  isUnprocessableEntity() {
    return this.status === HttpStatusCode.UnprocessableEntity;
  }
  isLocked() {
    return this.status === HttpStatusCode.Locked;
  }
  isFailedDependency() {
    return this.status === HttpStatusCode.FailedDependency;
  }
  isTooManyRequests() {
    return this.status === HttpStatusCode.TooManyRequests;
  }
  isInternalServerError() {
    return this.status === HttpStatusCode.InternalServerError;
  }
  isNotImplemented() {
    return this.status === HttpStatusCode.NotImplemented;
  }
  isBadGateway() {
    return this.status === HttpStatusCode.BadGateway;
  }
  isServiceUnavailable() {
    return this.status === HttpStatusCode.ServiceUnavailable;
  }
  isGatewayTimeout() {
    return this.status === HttpStatusCode.GatewayTimeout;
  }
}
